import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { GeneralSetupForm } from './GeneralSetupForm';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import BlankLogo from '@app/illu/Branding/BlankLogoBUX.svg';
import { NewFeatureBanner } from 'components/NewFeatureBanner';
import { Button } from '@app/core';
import { useTranslation } from 'react-i18next';
import { useIsSpecialOfferBannerActive } from 'components';
import { SpecialOfferQuoteBlock } from 'components/SpecialOffer/SpecialOfferQuoteBlock';

const HEAD_SIZE = 600;

const useStyles = createUseStyles((theme: Theme) => ({
  mainContainer: {
    backgroundColor: theme.colors.white,
    minHeight: '100%',
    background: `linear-gradient(to bottom, ${theme.colors.inkPrimary} ${HEAD_SIZE}px, white ${HEAD_SIZE}px)`,
  },
  logo: {
    marginTop: theme.marginBase * 3,
    height: theme.height.small,
  },
  banner: {
    position: 'relative',
  },
  helpBlock: {
    marginTop: theme.marginBase * 7,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.marginBase * 2,
    backgroundColor: theme.colors.accentMuted,
    padding: theme.marginBase * 3,
    width: '100%',
    borderRadius: theme.borderRadius.std,
  },
  helpBlockTextContainer: {
    flex: 1,
  },
  helpBlockTitle: {
    ...theme.fonts.h4,
  },
  container: {
    maxWidth: 800 + theme.marginBase * 32,
    margin: 'auto',
  },
  top: {
    [theme.media.tablet]: {
      paddingRight: theme.marginBase * 3,
      paddingLeft: theme.marginBase * 3,
    },
  },
  title: {
    ...theme.fonts.h1,
    marginTop: theme.marginBase * 9,
    color: theme.colors.white,
    [theme.media.tablet]: {
      ...theme.fonts.h3,
      color: theme.colors.white,
    },
  },
  main: {
    marginTop: theme.marginBase * 7,
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.std,
    paddingTop: theme.marginBase * 9,

    padding: theme.marginBase * 16,
    [theme.media.tablet]: {
      paddingRight: theme.marginBase * 6,
      paddingLeft: theme.marginBase * 6,
    },
    [theme.media.mobile]: {
      paddingRight: theme.marginBase * 3,
      paddingLeft: theme.marginBase * 3,
    },
  },
}));

export const AnonymousQuote = () => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  const isSpecialOfferActive = useIsSpecialOfferBannerActive();

  return (
    <AnalyticsCategoryProvider category={Categories.STUDY_CREATION}>
      <div className={classes.mainContainer}>
        <NewFeatureBanner className={classes.banner} />

        <div className={classes.container}>
          <div className={classes.top}>
            <a href="https://www.bilendi-ux.com" rel="Go to Home">
              <img
                src={BlankLogo}
                alt="Bilendi UX's logo"
                className={classes.logo}
              />
            </a>
            <h1 className={classes.title}>{t('studySetup.bgTitle')}</h1>
            {isSpecialOfferActive ? (
              <SpecialOfferQuoteBlock />
            ) : (
              <div className={classes.helpBlock}>
                <div className={classes.helpBlockTextContainer}>
                  <h3 className={classes.helpBlockTitle}>
                    {t('studySetup.helpBlock.title')}
                  </h3>
                </div>
                <Button
                  color="accent"
                  text={t('studySetup.helpBlock.button')}
                  href="https://www.bilendi-ux.com/book-demo"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              </div>
            )}
          </div>
          <div className={classes.main}>
            <GeneralSetupForm source="TANDEMZ" />
          </div>
        </div>
      </div>
    </AnalyticsCategoryProvider>
  );
};
